<div class="ds ds-dialog is-complex ds-dialog--info solicitud-dialog">
	<!-- Cabecera -->
	<div class="ds-dialog__head">
		<span class="ds-dialog__icon"><mat-icon>outgoing_mail</mat-icon></span>
		<div class="ds-dialog__titles">
			<h2 class="ds-dialog__title">{{ "solicitudDatos.title" | translate }}</h2>
			<p class="ds-dialog__sub">{{ "solicitudDatos.sub" | translate : { codigo: data.entityCodigo || "—", nombre: data.entityNombre || "—" } }}</p>
		</div>
		<button type="button" class="ds-dialog__x" (click)="close()" [attr.aria-label]="'common.close' | translate"><mat-icon>close</mat-icon></button>
	</div>

	<!-- Cuerpo -->
	<div class="ds-dialog__body">
		<!-- Cargando personas de la entidad -->
		<div class="dlg-state" *ngIf="isLoading">
			<span class="sd-spinner"></span>
			<p>{{ "common.loading" | translate }}</p>
		</div>

		<!-- Error de carga -->
		<div class="dlg-state" *ngIf="!isLoading && hasError">
			<mat-icon>error_outline</mat-icon>
			<p>{{ "solicitudDatos.sinPersonas" | translate }}</p>
		</div>

		<ng-container *ngIf="!isLoading && !hasError">
			<!-- ===== Destinatario ===== -->
			<div class="ds-dialog__section">{{ "solicitudDatos.destinatario" | translate }}</div>

			<!-- Sin personas con email: aviso y envío deshabilitado -->
			<div class="sd-empty" *ngIf="sinPersonas">
				<mat-icon>person_off</mat-icon>
				<p>{{ "solicitudDatos.sinPersonas" | translate }}</p>
			</div>

			<ng-container *ngIf="seleccionado">
				<!-- Card de la persona seleccionada -->
				<div class="sd-person is-selected">
					<app-empleado-avatar [empleado]="empleadoLikeOf(seleccionado)"></app-empleado-avatar>
					<div class="sd-person-tx">
						<b>{{ nombreDe(seleccionado) }}</b>
						<span class="sd-meta" *ngIf="seleccionado.puestoDescription">{{ seleccionado.puestoDescription }}</span>
						<span class="sd-mail">{{ seleccionado.empleadoEmail }}</span>
					</div>
					<span class="pill ok" *ngIf="seleccionado.esResponsable">{{ "solicitudDatos.responsable" | translate }}</span>
				</div>

				<!-- Cambiar destinatario (expand inline, solo si hay más personas) -->
				<button type="button" class="sd-change" *ngIf="otrosCandidatos.length" (click)="toggleLista()" [class.open]="listaAbierta">
					<mat-icon>swap_horiz</mat-icon>
					<span>{{ "solicitudDatos.cambiarDestinatario" | translate }}</span>
					<mat-icon class="cv">arrow_drop_down</mat-icon>
				</button>

				<div class="sd-list" *ngIf="listaAbierta">
					<button type="button" class="sd-person sd-option" *ngFor="let c of otrosCandidatos" (click)="seleccionar(c)">
						<app-empleado-avatar [empleado]="empleadoLikeOf(c)"></app-empleado-avatar>
						<div class="sd-person-tx">
							<b>{{ nombreDe(c) }}</b>
							<span class="sd-meta" *ngIf="c.puestoDescription">{{ c.puestoDescription }}</span>
							<span class="sd-mail">{{ c.empleadoEmail }}</span>
						</div>
						<span class="pill ok" *ngIf="c.esResponsable">{{ "solicitudDatos.responsable" | translate }}</span>
					</button>
				</div>
			</ng-container>

			<!-- ===== Mensaje ===== -->
			<div class="ff-field sd-msg">
				<label>{{ "solicitudDatos.mensajeLabel" | translate }}<span class="req">*</span></label>
				<div class="ff-box">
					<textarea
						rows="5"
						[formControl]="mensajeCtrl"
						[attr.maxlength]="mensajeMax"
						[placeholder]="'solicitudDatos.mensajePlaceholder' | translate"
					></textarea>
				</div>
				<div class="sd-counter">{{ mensajeCtrl.value.length || 0 }}/{{ mensajeMax }}</div>
			</div>

			<!-- Nota informativa -->
			<div class="ds-dialog__note sd-note">
				<mat-icon>info</mat-icon>
				<div class="ds-dialog__note-tx"><p>{{ "solicitudDatos.nota" | translate }}</p></div>
			</div>
		</ng-container>
	</div>

	<!-- Pie -->
	<div class="ds-dialog__footer">
		<button type="button" class="btn btn-ghost" (click)="close()" [disabled]="isSending">{{ "common.cancel" | translate }}</button>
		<button type="button" class="btn btn-primary" (click)="onEnviar()" [disabled]="!canSend">
			<span class="sd-spinner sm" *ngIf="isSending"></span>
			<span class="ic" *ngIf="!isSending"><mat-icon [inline]="true">send</mat-icon></span>
			{{ "solicitudDatos.enviar" | translate }}
		</button>
	</div>
</div>
